webpackJsonp([70144966829960],{

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Divider = __webpack_require__(6);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Contact = function Contact() {
	  return _react2.default.createElement(
	    'section',
	    null,
	    _react2.default.createElement(
	      'article',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { style: { display: 'block' } },
	        _react2.default.createElement(
	          'h1',
	          { className: 'smallerHone' },
	          'Contact'
	        ),
	        _react2.default.createElement('img', { src: _Divider2.default, alt: 'Nisadhya - Divider', style: { margin: '.75rem 0' } }),
	        _react2.default.createElement(
	          'p',
	          { className: 'smallerHone' },
	          _react2.default.createElement(
	            'span',
	            { className: 'gradient' },
	            'Leave us a quick message or feel free to visit us anytime!'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          { style: { marginBottom: '0' } },
	          'See how businesses similar to yours are growing with Digital Marketing.'
	        )
	      )
	    )
	  );
	};
	
	exports.default = Contact;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-a5de96f809d066b66d1a.js